"use client";

import i18n, { InitOptions } from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "@/resources/locale/en.json";
import ko from "@/resources/locale/ko.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)

  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: en,
      },
      ko: {
        translation: ko,
      },
    },
    keySeparator: false,
    allowObjectInHTMLChildren: true,
    react: {
      useSuspense: true,
    },
  } as InitOptions);

export default i18n;
